(function () {

    'use strict';

    angular.module('iplusjs.validator.group', [
        'lodash'
    ])
        .directive('iplusjsValidatorGroup', validatorGroup);

    validatorGroup.$inject = [];
    function validatorGroup() {
        return {
            restrict: 'A',
            require: 'ngModel',
            controller: ValidatorGroupController,
            controllerAs: 'validatorGroupVm'
        };
    }

    ValidatorGroupController.$inject = [
        'lodash'
    ];
    function ValidatorGroupController(_) {
        var vm = this;

        vm.$onInit = onInit;
        vm.addItem = addItem;
        vm.getItems = getItems;

        function onInit() {
            vm.validatorItems = [];
        }

        function addItem(item) {
            _.remove(vm.validatorItems, function (validatorItem) {
                return _.get(validatorItem, 'modelPropName') === _.get(item, 'modelPropName');
            });

            vm.validatorItems.push(item);
        }

        function getItems() {
            return vm.validatorItems;
        }
    }
})();
